import React from 'react';
import { Image, ImageProps } from 'expo-image';
import { ImageURISource } from 'react-native';
import { useLimitedPerformanceEnabled } from '@/hooks/use-limited-performance';

export interface CachedImageProps extends ImageProps {
  defaultSource?: ImageURISource;
  loadingIndicatorSource?: ImageURISource;
  source: ImageURISource;
}

export const CachedImage: React.FC<CachedImageProps> = (props) => {
  const limitedPerformanceEnabled = useLimitedPerformanceEnabled();

  return (
    <Image
      accessibilityLabel={props.accessibilityLabel ?? props.alt} // alt doesn't get passed to <img> on web unless accessibilityLabel is set
      cachePolicy={limitedPerformanceEnabled ? 'none' : 'disk'}
      {...props}
    />
  );
};
